import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ActivityViewRouteA11yService {
	private nextRouteAnnouncementPoliteness: 'polite' | 'assertive' | null = null;
	private nextRouteFocusSelector: string | null = null;

	public setNextRouteAnnouncementPoliteness (politeness: 'polite' | 'assertive'): void {
		this.nextRouteAnnouncementPoliteness = politeness;
	}

	public consumeNextRouteAnnouncementPoliteness (): 'polite' | 'assertive' | null {
		const politeness = this.nextRouteAnnouncementPoliteness;
		this.nextRouteAnnouncementPoliteness = null;
		return politeness;
	}

	public setNextRouteFocusSelector (selector: string): void {
		this.nextRouteFocusSelector = selector;
	}

	public peekNextRouteFocusSelector (): string | null {
		return this.nextRouteFocusSelector;
	}

	public consumeNextRouteFocusSelector (): string | null {
		const selector = this.nextRouteFocusSelector;
		this.nextRouteFocusSelector = null;
		return selector;
	}
}
